import * as React from 'react';

const ImageChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="image-chunky_svg__eds-icon--image-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="image-chunky_svg__eds-icon--image-chunky_base"
            d="M6 18h12V6H6v12zM4 4h16v16H4V4z"
        />
        <path
            id="image-chunky_svg__eds-icon--image-chunky_sun"
            d="M17 9.5c0-.8-.7-1.5-1.5-1.5S14 8.7 14 9.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5z"
        />
        <path
            id="image-chunky_svg__eds-icon--image-chunky_mountain"
            d="M17 16l-2.7-3-1.3 1-2-2.9L7 16h6.9z"
        />
    </svg>
);

ImageChunkySvg.displayName = 'ImageChunkySvg';
export default ImageChunkySvg;
